<div>
  <input
    type="text"
    [class]="cssClasses"
    ngbDatepicker
    #d="ngbDatepicker"
    [(ngModel)]="date"
    id="{{product.id}}"
    (dateSelect)="onDateSelect($event);"
  />
  <button
    class="btn btn-outline-secondary bi bi-calendar3"
    (click)="d.toggle()"
    type="button"
  ></button>
</div>
